import { getUnsubmittedApplication } from './application';
import { isObjectEmpty } from './object';

export const getSlugByPathName = (pathname) => {
  const segments = pathname.split('/');
  return segments[segments.length - 1];
};

export function isRedirectAllowed(nextRoute, routeNames = []) {
  if (routeNames.length <= 0) {
    return true;
  }
  return (
    routeNames.filter((routeName) => {
      if (nextRoute) {
        const nextRouteWithoutParam = (nextRoute.split('/?')[0] || '').split('?')[0];

        return nextRouteWithoutParam.includes(routeName);
      }
      return false;
    }).length > 0
  );
}

/**
 * @function getOnboardingRedirect
 * @description Return final pathname for Onboarding redirects for non-RESP users
 * @param {Array<Object>} pendingApplications
 */

export const getOnboardingRedirectPath = (pendingApplications) => {
  const isPrenatalOnboardingIncomplete = !isObjectEmpty(
    getUnsubmittedApplication(pendingApplications, 'PrenatalOnboarding')
  );

  return isPrenatalOnboardingIncomplete ? '/main/newbaby-onboarding' : '/main/newonboarding';
};
